const { Component } = Shopware;

Component.register('sellops-order-editing-config-redirect', {
    template: `<div></div>`,

    created() {
        this.$router.push({
            name: 'sw.plugins.config',
            params: { namespace: 'SellopsLimitedOrderEditing' },
        });
    },
});
